import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonMenu } from 'components/ButtonMenu';
import { SxProps, Theme } from '@mui/material';
import useGetMenuItems from './hooks/useGetMenuItems';

type Props = {
    exportTableData?: FlowAnyFunction;
    exportPng?: FlowAnyFunction;
    exportExcelData?: FlowAnyFunction;
    buttonStyles?: SxProps<Theme>;
};

const ExportMenuButton = ({
    exportTableData = undefined,
    exportPng = undefined,
    exportExcelData = undefined,
    buttonStyles = undefined,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const menuItems = useGetMenuItems(
        exportTableData,
        exportPng,
        exportExcelData,
    );

    // We don't want to show an empty menu while data is loading
    if (menuItems.length === 0) return <></>;
    const button = (
        <ButtonMenu
            buttonLabel={t('common.export')}
            menuItems={menuItems}
            extra={{ variant: 'outlined' }}
            sx={buttonStyles}
        />
    );
    return button;
};

export default ExportMenuButton;
